
class TradeDetailsController {
  public tradeDetails;

  /** @ngInject */
  constructor(private $mdDialog: angular.material.IDialogService) { }

  calculatePercentage(trade) {
    return trade.quantityRecovered / this.normalizeQuantity(trade.buySellQuantity) * 100
  }

  normalizeQuantity(quantity: number) {
    return Math.abs(quantity)
  }

  convertToReadableStatus(status: string) {
    if (!status) {
      return 'Simulation'
    }

    switch (status) {
      case 'NEW':
        return 'New Trade Sheet';
      case 'SUBMITTED':
        return 'At Trade Administrator';
      case 'SENT':
        return 'At Broker';
    }
  }

  close() {
    this.$mdDialog.hide(true)
  }
}

export const tradeDetailsModal: angular.IComponentOptions = {
  template: require('./tradeDetails.modal.html'),
  controller: TradeDetailsController,
  bindings: {
    tradeDetails: "<",
  }
}



// WEBPACK FOOTER //
// ./src/app/portfolioadmin/tradeRecommendations/tradeDetails.modal.ts